import React from 'react';
import { motion } from 'framer-motion';
import { Code2, Accessibility, Cctv, Truck, GraduationCap, Stethoscope, ArrowUpRight } from 'lucide-react';
const competencies = [{
  title: 'Software Development',
  description: 'Custom desktop and mobile applications engineered for NIST 800-171 and 800-53 compliance. Secure lifecycle management from concept to deployment.',
  icon: Code2,
  tags: ['NIST 800-171', 'DevSecOps']
}, {
  title: 'Web & Accessibility',
  description: 'WCAG 2.1 AA/AAA compliant design for responsive government portals. We bridge the gap between complex data and user-centric accessibility.',
  icon: Accessibility,
  tags: ['Section 508', 'WCAG 2.1']
}, {
  title: 'Physical Security',
  description: 'Commercial-grade camera systems and access control installation. Integrated digital-physical security solutions for agency facilities.',
  icon: Cctv,
  tags: ['Access Control', 'Surveillance']
}, {
  title: 'IT Supply Chain',
  description: 'End-to-end hardware procurement, specialized I.T. supplies, and logistics management. TAA-compliant sourcing for federal requirements.',
  icon: Truck,
  tags: ['TAA Compliant', 'Logistics']
}, {
  title: 'Training & Human Capital',
  description: 'Specialized technical training programs designed for agency staff. Upskilling federal workforces in cybersecurity and modern tech stacks.',
  icon: GraduationCap,
  tags: ['Workforce Dev', 'Tech Training']
}, {
  title: 'Healthcare IT',
  description: 'HIPAA-compliant system architecture and secure data management. Modernizing clinical workflows with high-trust digital infrastructure.',
  icon: Stethoscope,
  tags: ['HIPAA', 'Data Security']
}];
export function CompetencyGrid() {
  return <section id="capabilities" className="py-12 bg-slate-50" data-id="element-106">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-107">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-108">
          <div className="max-w-2xl" data-id="element-109">
            <h2 className="text-federal-blue text-sm font-black tracking-[0.2em] uppercase mb-4" data-id="element-110">
              Core Competencies
            </h2>
            <p className="text-3xl md:text-4xl font-bold text-tech-slate leading-tight" data-id="element-111">
              An Expanded Ecosystem of <br data-id="element-112" />
              <span className="text-federal-blue" data-id="element-113">Technical Excellence.</span>
            </p>
          </div>
          <div className="h-px flex-grow bg-slate-200 mx-8 hidden lg:block" data-id="element-114" />
          <p className="text-tech-slate/70 text-sm max-w-xs font-medium" data-id="element-115">
            Modular solutions designed to meet the rigors of federal compliance
            and mission-critical reliability.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-116">
          {competencies.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-white p-8 border border-slate-200 hover:border-federal-blue transition-all duration-300 relative overflow-hidden shadow-sm hover:shadow-xl" data-id="element-117">
              <div className="absolute top-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-118">
                <ArrowUpRight className="w-5 h-5 text-muted-gold" data-id="element-119" />
              </div>
              <div className="w-14 h-14 bg-slate-50 flex items-center justify-center mb-8 group-hover:bg-federal-blue transition-colors duration-300" data-id="element-120">
                <item.icon className="w-7 h-7 text-federal-blue group-hover:text-white transition-colors" data-id="element-121" />
              </div>
              <h3 className="text-xl font-bold text-federal-blue mb-4" data-id="element-122">
                {item.title}
              </h3>
              <p className="text-tech-slate text-sm leading-relaxed mb-8 opacity-80" data-id="element-123">
                {item.description}
              </p>
              <div className="flex flex-wrap gap-2 mt-auto" data-id="element-124">
                {item.tags.map((tag, tIdx) => <span key={tIdx} className="text-[10px] font-bold tracking-wider uppercase px-2 py-1 bg-slate-100 text-tech-slate" data-id="element-125">
                    {tag}
                  </span>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}